import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonInput } from '@ionic/angular';
import { Product } from 'src/app/models/core/product.model';

@Component({
  selector: 'app-venta-rapida-price-step',
  templateUrl: './venta-rapida-price-step.component.html',
  styleUrls: ['./venta-rapida-price-step.component.scss'],
  standalone: false
})
export class VentaRapidaPriceStepComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input({ required: true }) product!: Product;
  @Input() submitting = false;

  @Output() generate = new EventEmitter<number>();
  @ViewChild('amountInput') amountInput?: IonInput;

  form!: FormGroup;
  private focusTimeoutId?: ReturnType<typeof setTimeout>;

  constructor(private readonly _fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this._fb.group({
      amount: [null, [Validators.required, Validators.min(0)]],
    });
  }

  ngAfterViewInit(): void {
    // Delay focus a bit to avoid clashing with modal transition.
    this.focusTimeoutId = setTimeout(() => {
      this.amountInput?.setFocus();
    }, 220);
  }

  ngOnDestroy(): void {
    if (this.focusTimeoutId) {
      clearTimeout(this.focusTimeoutId);
    }
  }

  isValid(): boolean {
    const value = this.form?.get('amount')?.value;
    if (value === null || value === undefined || value === '') return false;
    const n = Number(value);
    return Number.isFinite(n) && n >= 0;
  }

  onGenerate(): void {
    if (this.submitting) return;
    if (!this.isValid()) return;
    const amount = Number(this.form.get('amount')?.value);
    this.generate.emit(amount);
  }
}
